import { render, staticRenderFns } from "./wrapper-observe-visibility.vue?vue&type=template&id=4c239676&"
import script from "./wrapper-observe-visibility.vue?vue&type=script&lang=js&"
export * from "./wrapper-observe-visibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports